import { all, call, put, spawn, take } from 'redux-saga/effects';
import * as notify from '../../containers/layout/Notifications/actions';
import { ConnectionError } from '../app/errors';
import { FREE_BETS_REQUEST, freeBetsFailure, freeBetsSuccess } from './actions';
import { getFreeBets } from './rest';

export function* watchFreeBetsRequest() {
  while (yield take(FREE_BETS_REQUEST)) {
    try {
      const results = yield call(getFreeBets);
      yield put(freeBetsSuccess(results));
    } catch (e) {
      yield put(freeBetsFailure());
      if (e instanceof ConnectionError) {
        yield put(notify.add('Connection error.', notify.ERROR));
      }
    }
  }
}

export default function* root() {
  yield all([
    spawn(watchFreeBetsRequest)
  ]);
}
